import '@tiptap/extension-text-style';
import { Extension } from '@tiptap/core';

/**
 * This extension allows the display style to be added to textStyle (span) elements. 
 * For example, html like: <span style='display:inline-block'>My Text</span> is accepted as valid. 
 * We need this just for being able to accept server 'generated' markup. We do not allow clients to use it with commands. 
 * 
 */
const TextDisplay = Extension.create({
    name: 'textDisplay',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    textDisplay: {
                        default: null,
                        parseHTML: element => { var _a; return (_a = element.style.display) === null || _a === void 0 ? void 0 : _a.replace(/['"]+/g, ''); },
                        renderHTML: attributes => {
                            if (!attributes.textDisplay) {
                                return {};
                            }
                            return {
                                style: `display: ${attributes.textDisplay}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setTextDisplay: textDisplay => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { textDisplay })
                    .run();
            },
            unsetTextDisplay: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { textDisplay: null })
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});

export { TextDisplay, TextDisplay as default };